import { css } from 'emotion'

export const marginBottomSmallStyles = css`
  margin-bottom: 8px;
`
